import ProductImage from '@moncler/components/product/ProductImage';
import AccordionItem from '@ui/accordion/AccordionItem';
import RadioGroup from '@ui/radioGroup/RadioGroup';
import RadioGroupItem from '@ui/radioGroup/RadioGroupItem';
import api from '@utils/api';
import { LG, MD, SM } from '@utils/imageutils';
import { calculateDateforJP } from '@utils/stringUtils';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ColorAndSize from '@common/components/aftercare/ColorAndSize';
const AftercareOrderItem = (props) => {
    const { t } = useTranslation();
    const [orderDetail, setOrderDetail] = useState();
    const [selectedProduct, setSelectedProduct] = useState();
    const onOpen = () => {
        api.getOrderDetail(props.order.orderNumber).then((data) => {
            setOrderDetail(data);
        });
    };
    const createTitleMarkup = (order) => (React.createElement("div", { className: "orders-listing__order-detail" },
        React.createElement("div", { className: "order-detail__column" },
            React.createElement("h2", null,
                React.createElement("span", { className: "dt" }, t('orderhistory.ordernumber')),
                React.createElement("span", { className: "dd" }, order.orderNumber))),
        React.createElement("p", { className: "order-detail__column" },
            React.createElement("span", { className: "dt" }, t('label.date')),
            React.createElement("span", { className: "dd" }, calculateDateforJP(order.creationDate)))));
    return (React.createElement(AccordionItem, Object.assign({ title: createTitleMarkup(props.order), isTitleMarkup: true, headerClass: "accordion__header--cta-text", accordionId: props.order.orderNumber }, props, { callbackOnOpen: () => onOpen() }), orderDetail && (React.createElement("div", { className: "items-container items-container--box" },
        React.createElement(RadioGroup, { type: "product", id: 'order' + orderDetail.orderNumber, setSelected: (id) => {
                setSelectedProduct(id);
                props.selectItem(id);
            } }, orderDetail === null || orderDetail === void 0 ? void 0 : orderDetail.items.map((item) => (React.createElement(RadioGroupItem, { key: item.UUID, content: React.createElement("div", { className: "optionbox__item__content" },
                React.createElement("div", { className: "option-product__image", "aria-hidden": "true" },
                    React.createElement(ProductImage, { sizes: [LG, MD, SM], img: item.imgs, type: "F", tiletype: (item === null || item === void 0 ? void 0 : item.isMbm) ? 'mbm' : '' })),
                React.createElement("div", null,
                    React.createElement("h3", { className: "option-product__name" }, item.productName),
                    React.createElement("p", { className: "option-product__price" }, item.totalPrice),
                    React.createElement(ColorAndSize, { item: item }))), id: item, selected: (item === null || item === void 0 ? void 0 : item.UUID) === (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.UUID) }))))))));
};
export default AftercareOrderItem;
